import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

/** The product name: the whole document title on a route with none of its own, the suffix otherwise. */
export const APP_TITLE = 'AnotherTrip Operator';

/**
 * Names every page in the browser tab and for screen readers: `{route title} | AnotherTrip Operator`.
 *
 * The title comes from the route's static `title`, and the deepest route that sets one wins, so a
 * child with none (the handle-search tabs) reads its parent's. Routes about one record (a campaign,
 * a brand) carry a generic noun rather than the record's name: naming it would mean fetching it here,
 * and the page already says which one it is.
 */
@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot);
    this.title.setTitle(pageTitle ? `${pageTitle} | ${APP_TITLE}` : APP_TITLE);
  }
}
